import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Typography, InputBase } from '@mui/material';
import Moment from 'react-moment';
import { getTransactionHistoryApi } from '../../apis';
import { AiOutlineSearch } from 'react-icons/ai';
import CustomPagination from './CustomPagination';
import CustomNoRowsOverlay from '../../PageComponent/PlaceholderDatatable';

function TranstationHistory({ doctorId = null }) {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const pageSize = 10;
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoader(true);
        const res = await getTransactionHistoryApi(doctorId);
        if (res.status === 200) {
          const transformed = res.data.TransactionHistory.map((item, index) => ({
            id: index + 1,
            hospitalName: item?.hospitalName?.[0] || '',
            specialization: item?.Specalaization?.[0] || '',
            type: item?.consultationType?.[0] || '',
            completedDate: item?.ConsultationCompletedDate?.[0] || '',
            payment: item?.DoctorFee || '',
            status: item?.Paymentstatus === 'paid' ? 'Success' : 'Pending',
          }));
          setData(transformed);
        }
      }
      catch (error) {
        setLoader(false);
        console.log(error);
      }
    };
    fetchData();
  }, [doctorId]);

  const filteredData = data.filter((row) =>
    Object.values(row).some((val) =>
      String(val).toLowerCase().includes(search.toLowerCase())
    )
  );

  const paginatedRows = filteredData.slice(page * pageSize, (page + 1) * pageSize);
  const totalPages = Math.ceil(filteredData.length / pageSize);

  const columns = [
    { field: 'hospitalName', headerName: 'Hospital Name', flex: 1 },
    { field: 'specialization', headerName: 'Specialization', flex: 1 },
    {
  field: 'type',
  headerName: 'Type',
  flex: 1,
  align: 'center',
  headerAlign: 'center',
  renderCell: (params) => (
    <p className="capitalize">{params.value}</p>
  ),
},
    {
      field: 'completedDate',
      headerName: 'Completed Date',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => <Moment format="DD/MM/YYYY">{params.value}</Moment>,
    },
    {
      field: 'payment',
      headerName: 'Payment',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => `₹ ${params.value}`,
    },
    {
      field: 'status',
      headerName: 'Payment Status',
      flex: 1,
    },
  ];

  return (
    <Box p={2}>
      <div className="flex justify-between items-center px-4 py-2 bg-[#f3f8ff] rounded-t-lg">
        <p className='text-coalBlack headingText capitalize'>Consultation History</p>
        <div className="w-[300px] flex items-center gap-2 border border-slate-300 rounded px-2 py-1 bg-white">
          <AiOutlineSearch className="text-slate-500" />
          <InputBase
            placeholder="Search"
            className="text-sm"
            value={search}
            onChange={(e) => {
              setPage(0);
              setSearch(e.target.value);
            }}
          />
        </div>
      </div>

      <DataGrid
        slots={{ noRowsOverlay: CustomNoRowsOverlay }}
        rows={paginatedRows}
        columns={columns}
        autoHeight
        hideFooter
        disableColumnMenu
        disableRowSelectionOnClick
        disableColumnSorting
        sx={{
         fontFamily: 'var(--font-family)', 
          '--DataGrid-overlayHeight': '80px',
          '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell:focus-within': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell--withRenderer': {
            padding: '8px',
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#ffff',
            borderBottom: '1px solid #e2e8f0',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold',
            textAlign: 'left'
          },
        }}

      />

      <CustomPagination page={page} totalPages={totalPages} setPage={setPage} />
    </Box>
  );
}

export default TranstationHistory;
